import * as React from 'react'
import { PropsWithChildren } from 'react'

import { HighlightedBox, HighlightedBoxColor } from './HighlightedBox'

function getColorForValue(value: number): HighlightedBoxColor {
  if (!value) {
    return HighlightedBoxColor.Neutral
  } else if (value <= -10) {
    return HighlightedBoxColor.DarkRed
  } else if (value <= -5) {
    return HighlightedBoxColor.MediumRed
  } else if (value < 0) {
    return HighlightedBoxColor.LightRed
  } else if (value >= 10) {
    return HighlightedBoxColor.DarkGreen
  } else if (value >= 5) {
    return HighlightedBoxColor.MediumGreen
  } else {
    return HighlightedBoxColor.LightGreen
  }
}

interface OhlcPriceChangeProps {
  className?: string
  value?: number | null
}

export function OhlcPriceChange({ children, className, value }: PropsWithChildren<OhlcPriceChangeProps>) {
  if (!Number.isFinite(value)) {
    return null
  }
  return (
    <HighlightedBox className={className} color={getColorForValue(value as number)}>
      {children}
    </HighlightedBox>
  )
}
